export const defaults = {
	pageDetails: { pageNo: 1, pageSize: 10 }
};

export const GET_LOTTERY_WINNINGS_LIST_ENDPOINT = '/dashboard/getLotteryWinnerData/userProfile-lotteryWinnings-getLotteryWinningList';
